/**
 * Product Gallery V2
 * Управление галереей изображений продукта с миниатюрами
 */

(function () {
if (window.ProductGalleryV2) {
  if (typeof window.initProductGalleries === 'function') {
    window.initProductGalleries();
  }
  return;
}

class ProductGalleryV2 {
  constructor(container) {
    this.container = container;
    
    // Сначала пытаемся найти по ID (самый надежный способ)
    const productInfo = this.container.closest('product-info');
    const sectionId = productInfo?.dataset.section;
    
    if (sectionId) {
      this.mainImage = document.querySelector(`#MainProductImage-${sectionId}`);
    }
    
    // Если не нашли по ID, ищем по селектору, исключая изображения в тегах
    if (!this.mainImage) {
      const allImages = this.container.querySelectorAll('.product-img img');
      // Ищем изображение, которое НЕ находится внутри .product-image-tags
      this.mainImage = Array.from(allImages).find(img => 
        !img.closest('.product-image-tags')
      );
    }
    
    this.thumbnails = this.container.querySelectorAll('.product-image-tumb-img');
    
    if (!this.mainImage) {
      console.warn('ProductGalleryV2: основное изображение не найдено');
      return;
    }
    
    this.init();
  }
  
  init() {
    console.log('ProductGalleryV2: инициализация галереи', {
      thumbnailsCount: this.thumbnails.length,
      mainImage: this.mainImage
    });
    
    // Добавляем обработчики кликов на миниатюры
    if (this.thumbnails.length > 0) {
      this.thumbnails.forEach((thumbnail, index) => {
        // Создаем обработчик клика
        const handleClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('Клик по миниатюре:', index, thumbnail);
          this.switchImage(thumbnail);
        };
        
        // Добавляем обработчик клика
        thumbnail.addEventListener('click', handleClick);
        
        // Поддержка клавиатуры для доступности
        thumbnail.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            this.switchImage(thumbnail);
          }
        });
        
        // Делаем миниатюры доступными для клавиатуры
        thumbnail.setAttribute('tabindex', '0');
        thumbnail.setAttribute('role', 'button');
        thumbnail.setAttribute('aria-label', 'Переключить изображение');
        
        // Добавляем курсор pointer для визуальной обратной связи
        thumbnail.style.cursor = 'pointer';
      });
    } else {
      console.warn('ProductGalleryV2: миниатюры не найдены');
    }
  }
  
  switchImage(thumbnail) {
    console.log('ProductGalleryV2: переключение изображения', thumbnail);
    
    // Получаем URL полного изображения из data-атрибута
    const thumbnailImg = thumbnail.querySelector('img');
    if (!thumbnailImg) {
      console.error('ProductGalleryV2: изображение в миниатюре не найдено');
      return;
    }
    
    // Убеждаемся, что мы работаем с правильным основным изображением
    // (не с иконками в тегах)
    if (!this.mainImage || this.mainImage.closest('.product-image-tags')) {
      // Переинициализируем поиск основного изображения
      const productInfo = this.container.closest('product-info');
      const sectionId = productInfo?.dataset.section;
      if (sectionId) {
        this.mainImage = document.querySelector(`#MainProductImage-${sectionId}`);
      }
      if (!this.mainImage) {
        const allImages = this.container.querySelectorAll('.product-img img');
        this.mainImage = Array.from(allImages).find(img => 
          !img.closest('.product-image-tags')
        );
      }
      if (!this.mainImage) {
        console.error('ProductGalleryV2: не удалось найти основное изображение');
        return;
      }
    }
    
    const fullSrc = thumbnailImg.dataset.fullSrc || thumbnailImg.src;
    console.log('ProductGalleryV2: переключение на изображение', fullSrc);
    
    // Обновляем основное изображение
    if (fullSrc && this.mainImage) {
      // Добавляем плавную загрузку
      this.mainImage.style.opacity = '0.5';
      this.mainImage.style.transition = 'opacity 0.3s ease';
      
      // Удаляем srcset и sizes перед загрузкой нового изображения
      this.mainImage.removeAttribute('srcset');
      this.mainImage.removeAttribute('sizes');
      
      // Создаем новое изображение для предзагрузки
      const img = new Image();
      img.onload = () => {
        console.log('ProductGalleryV2: изображение загружено');
        // Обновляем только src
        this.mainImage.src = fullSrc;
        this.mainImage.style.opacity = '1';
      };
      img.onerror = () => {
        console.error('ProductGalleryV2: ошибка загрузки изображения', fullSrc);
        // Если загрузка не удалась, возвращаем прозрачность
        this.mainImage.style.opacity = '1';
      };
      // Начинаем загрузку изображения
      img.src = fullSrc;
      
      // Обновляем alt текст
      const alt = thumbnailImg.alt;
      if (alt) {
        this.mainImage.alt = alt;
      }
    } else {
      console.error('ProductGalleryV2: нет URL изображения или основного изображения', {
        fullSrc,
        mainImage: this.mainImage
      });
    }
    
    // Обновляем активное состояние миниатюр
    this.thumbnails.forEach(thumb => {
      thumb.classList.remove('active');
      thumb.setAttribute('aria-pressed', 'false');
    });
    
    thumbnail.classList.add('active');
    thumbnail.setAttribute('aria-pressed', 'true');
  }
}

// Экспортируем класс для использования в других модулях
window.ProductGalleryV2 = ProductGalleryV2;

// Инициализация при загрузке DOM
function initProductGalleries() {
  const galleryContainers = document.querySelectorAll('.product-image-wrap');
  console.log('ProductGalleryV2: поиск контейнеров галереи, найдено:', galleryContainers.length);
  
  galleryContainers.forEach((container, index) => {
    if (container.dataset.galleryInitialized === 'true') return;
    console.log(`ProductGalleryV2: инициализация контейнера ${index}`, container);
    try {
      new ProductGalleryV2(container);
      container.dataset.galleryInitialized = 'true';
    } catch (error) {
      console.error('Ошибка инициализации галереи:', error);
    }
  });
}

window.initProductGalleries = initProductGalleries;

// Инициализация при полной загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('ProductGalleryV2: DOM загружен, инициализация галерей');
    initProductGalleries();
  });
} else {
  // Если DOM уже загружен, инициализируем сразу
  console.log('ProductGalleryV2: DOM уже загружен, инициализация галерей');
  // Небольшая задержка для гарантии, что все элементы на месте
  setTimeout(initProductGalleries, 50);
}

// Переинициализация при изменении варианта продукта
document.addEventListener('variant:change', () => {
  // Даем время на обновление DOM
  setTimeout(() => {
    initProductGalleries();
  }, 100);
});
})();
